export enum BookingOrderState {
  Pending = 1,
  Completed = 2
};